export const sampleReportUrl = "https://aka.ms/CaptureViewsReportEmbedConfig";
